export { default } from 'containers/AboutPage/AboutPage';
export { getStaticProps } from 'containers/AboutPage/AboutPage.data';
